// 繁體中文文案。新增 key 時各語言檔案保持同構。
import type { Messages } from "./zh-CN";

const zhTW: Messages = {
  common: {
    language: "語言",
    confirm: "確認",
    cancel: "取消",
    save: "儲存",
    delete: "刪除",
    edit: "編輯",
    search: "搜尋",
    loading: "載入中…",
    empty: "暫無資料",
  },
  nav: {
    workbench: "工作台",
    platform: "平台",
    myProjects: "我的專案",
    overview: "概覽",
    summarySettings: "摘要設定",
    growth: "增長",
    projectSettings: "專案設定",
    account: "帳號設定",
    aiCapability: "AI 能力",
    dataGrowth: "數據與成長",
    dataAccount: "數據與帳務",
    accessHelp: "接入與說明",
    admin: "管理台",
    home: "首頁",
    knowledge: "知識庫",
    agents: "智慧體",
    aiChat: "對話與掛件",
    podcast: "AI 播客",
    mcp: "MCP 服務",
    models: "模型中心",
    analytics: "網站分析",
    agentAudit: "Agent 操作稽核",
    chatHistory: "聊天記錄",
    tokenUsage: "消耗記錄",
    myOrders: "我的訂單",
    invitation: "我的邀請",
    codeGenerator: "網站接入",
    api: "對話 API",
    docs: "使用文件",
    about: "關於我們",
  },
  admin: {
    userManagement: "使用者管理",
    productManagement: "商品管理",
    orderManagement: "訂單管理",
    redeemCode: "兌換碼產生",
    dataControl: "數據管控",
    modelGateway: "模型閘道",
    systemSettings: "系統設定",
  },
  user: {
    settings: "使用者設定",
    orders: "我的訂單",
    usage: "消耗記錄",
    logout: "登出",
  },
  mcpServer: {
    needVip: "需要開通年費會員才能使用 MCP 用戶端功能",
    vipDesc: "升級到年費會員，即可使用 MCP 用戶端功能，連接第三方工具服務",
    backHome: "返回首頁開通會員",
    serverTab: "MCP 伺服器",
    clientTab: "MCP 用戶端",
  },
  payment: {
    invalidRedeem: "請輸入有效的兌換碼",
    redeemSuccess: "兌換成功",
  },
  modelCenter: {
    type: { chat: "對話", embedding: "向量", rerank: "重排序", image: "圖像" },
    filterAll: "全部",
    filterTools: "工具呼叫",
    filterImage: "圖像",
    empty: "暫無符合條件的模型",
    modelN: "模型 {{id}}",
    default: "預設",
    basicChat: "基礎對話",
    context: "上下文",
    maxOutput: "最大輸出",
    pendingPrice: "待定價",
    input: "輸入",
    output: "輸出",
    fetchFailed: "取得模型清單失敗",
    fetchFailedRetry: "取得模型清單失敗，請稍後重試",
  },
  oauth: {
    noCode: "授權失敗：未取得授權碼",
    loginSuccess: "{{provider}}登入成功！",
    bindSuccess: "{{provider}}帳號綁定成功",
    opFailed: "{{provider}}操作失敗",
    opFailedRetry: "{{provider}}操作失敗，請重試",
    processing: "正在處理{{provider}}登入...",
  },
  auth: {
    email: "電子郵件",
    password: "密碼",
    confirmPassword: "確認密碼",
    newPassword: "新密碼",
    confirmNewPassword: "確認新密碼",
    verifyCode: "驗證碼",
    emailVerifyCode: "電子郵件驗證碼",
    imageCaptcha: "圖形驗證碼",
    passkeyLogin: "通行金鑰登入",
    passwordLogin: "密碼登入",
    usePassword: "使用密碼登入",
    usePasskey: "使用通行金鑰登入",
    register: "註冊",
    registerTitle: "註冊帳號",
    resetTitle: "重設密碼",
    resetPassword: "重設密碼",
    noAccount: "還沒有帳號？立即註冊",
    haveAccount: "已有帳號？立即登入",
    forgotPassword: "忘記密碼？",
    backToLogin: "返回登入",
    sendCode: "發送驗證碼",
    getCaptcha: "取得驗證碼",
    retryAfter: "{{n}}秒後重試",
    otherLogin: "其他登入方式",
    githubLogin: "GitHub 登入",
    qqLogin: "QQ 登入",
    legacyTip: "舊版摘要 AI 和 PostChat 系統使用者請使用 QQ 直接登入，無需註冊",
    autoReturnTip: "登入後將自動返回您先前瀏覽的頁面",
    autoLoggingIn: "正在登入中，請稍候...",
    captchaAlt: "驗證碼",
    operatedBy: "由 北京洪繪科技店（個體工商戶）營運",
    userAgreement: "使用者協議",
    privacy: "隱私協議",
    rules: {
      requiredEmail: "請輸入電子郵件",
      invalidEmail: "請輸入有效的電子郵件地址",
      requiredPassword: "請輸入密碼",
      requiredVerifyCode: "請輸入驗證碼",
      requiredEmailCode: "請輸入電子郵件驗證碼",
      requiredCaptcha: "請輸入圖形驗證碼",
      requiredConfirm: "請確認密碼",
      requiredNewPassword: "請輸入新密碼",
      requiredConfirmNew: "請確認新密碼",
      passwordMin8: "密碼長度至少 8 位",
      passwordMin6: "密碼長度至少 6 位",
      passwordPattern: "密碼必須包含字母和數字",
      passwordMismatch: "兩次輸入的密碼不一致",
    },
    msg: {
      enterEmailFirst: "請先輸入電子郵件",
      passkeyFailed: "通行金鑰登入失敗",
      passkeyVerifyFailed: "通行金鑰驗證失敗",
      passkeyTryPassword: "通行金鑰登入失敗，請嘗試使用密碼登入",
      opCancelled: "操作被取消或沒有權限",
      securityError: "安全錯誤，可能是跨域問題",
      opAborted: "操作被中止",
      loginSuccessConsole: "登入成功，正在進入控制台",
      loginSuccessBack: "登入成功，正在返回您先前瀏覽的頁面",
      linkInvalid: "登入連結無效，請重新取得",
      linkExpired: "登入連結已過期，請重新取得",
      loginFailedManual: "登入失敗，請嘗試手動登入",
      tooManyAttempts: "登入嘗試次數過多，請稍後再試",
      wrongCredentials: "使用者名稱或密碼錯誤",
      enterValidEmailPwd: "請輸入正確的電子郵件和密碼",
      loginFailedRetry: "登入失敗，請重試",
      loginFailed: "登入失敗",
      systemError: "系統錯誤，請稍後重試",
      registerSuccess: "註冊成功！",
      registerFailed: "註冊失敗",
      codeSent: "驗證碼已發送",
      sendCodeFailed: "發送驗證碼失敗",
      captchaFailed: "取得驗證碼失敗",
      resetSuccess: "密碼重設成功！",
      resetFailed: "密碼重設失敗",
      resetFailedRetry: "密碼重設失敗，請重試",
    },
  },
  siteWorkspace: {
    back: "所有網站", aria: "網站功能", overview: "概覽", copilot: "Copilot", playbook: "主動劇本", knowledge: "知識", abilities: "能力", test: "測試", appearance: "外觀", analytics: "分析", settings: "設定", publish: "發佈中心",
    common: { retry: "重試", draft: "草稿", published: "已發佈", healthy: "健康", degraded: "已降級", confirmRequired: "執行前確認", noData: "暫無資料" },
    risk: { read: "唯讀", draft: "草稿", write: "寫入", sensitive: "敏感", financial: "資金", irreversible: "不可逆" },
    release: { ownerCanary: "僅站長", percent1: "1% 訪客", percent10: "10% 訪客", percent50: "50% 訪客", all: "全部訪客" },
  },
};

export default zhTW;
